export const NOTIFICATION_LIST_REQUEST = "NOTIFICATION_LIST_REQUEST";
export const NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_LIST_APPEND_SUCCESS = "NOTIFICATION_LIST_APPEND_SUCCESS";
export const NOTIFICATION_LIST_FAIL = "NOTIFICATION_LIST_FAIL";
export const NOTIFICATION_LIST_RESET = "NOTIFICATION_LIST_RESET";

export const NOTIFICATION_FILTER_SET = "NOTIFICATION_FILTER_SET";
export const NOTIFICATION_FILTER_ALL = "all";
export const NOTIFICATION_FILTER_UNREAD = "unread";

export const NOTIFICATION_MARK_READ_REQUEST = "NOTIFICATION_MARK_READ_REQUEST";
export const NOTIFICATION_MARK_READ_SUCCESS = "NOTIFICATION_MARK_READ_SUCCESS";
export const NOTIFICATION_MARK_READ_FAIL = "NOTIFICATION_MARK_READ_FAIL";

export const NOTIFICATION_MARK_ALL_READ_REQUEST = "NOTIFICATION_MARK_ALL_READ_REQUEST";
export const NOTIFICATION_MARK_ALL_READ_SUCCESS = "NOTIFICATION_MARK_ALL_READ_SUCCESS";
export const NOTIFICATION_MARK_ALL_READ_FAIL = "NOTIFICATION_MARK_ALL_READ_FAIL";

export const NOTIFICATION_UNREAD_COUNT_REQUEST = "NOTIFICATION_UNREAD_COUNT_REQUEST";
export const NOTIFICATION_UNREAD_COUNT_SUCCESS = "NOTIFICATION_UNREAD_COUNT_SUCCESS";
export const NOTIFICATION_UNREAD_COUNT_FAIL = "NOTIFICATION_UNREAD_COUNT_FAIL";

/** Realtime WS → store (NOTIFICATION-CONTRACT-CORRECTIONS-B1). */
export const NOTIFICATION_RECEIVED = "NOTIFICATION_RECEIVED";
export const NOTIFICATION_READ = "NOTIFICATION_READ";
